<template>
    <div :class="{...classes}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "Row",
        computed: {
            classes() {
                let res = {}
                let typeClass = this.getTypeClass()

                if (typeClass !== null) {
                    res[typeClass] = true
                }

                if (this.isMarginTop) {
                    res['mt-4'] = true
                }

                return res
            },

        },
        methods: {
            getTypeClass() {
                switch (this.type) {
                    case 'row':
                    case 'container':
                    case 'container-fluid':
                        return this.type

                    case 'form-row':
                        return 'form-group form-row'

                    case 'none':
                    default:
                        return null
                }
            },
        },
        props: {
            type: {
                type: String,
                default: 'row',
                validator: (value) => ['row', 'form-row', 'container', 'container-fluid', 'none'].indexOf(value) !== -1,
            },
            isMarginTop: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>

<style scoped>

</style>